import React, { useCallback } from 'react'
import { AppService } from '../../services'
import { AppState } from '../../stores/app'
import { useService } from '../../hooks/use-service'
import { getPathEntityId } from '../../_utils/get-path-entity-id'
import { OrgNotificationBuilderView } from '../../components/notification-builder/views/org-notification-builder-view'

export const OrgNotificationSend = () => {
    const appState = useService(AppState)
    const appSvc = useService(AppService)

    const getParentRoute = useCallback(
        (isDraft: boolean) => {
            return appSvc.routeWithin('org', isDraft ? '/notifications/drafts' : '/notifications', true)
        },
        [appState.currentDomain?.accountId],
    )

    const pathNotifId = getPathEntityId('notification') as string | undefined
    const builderMode = pathNotifId ? 'edit' : 'create'

    return <OrgNotificationBuilderView formMode={builderMode} getParentRoute={getParentRoute} />
}
